const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['薪資報表', 'Salary report', '薪资报表'],
				children: {
					ZZ_SYUGUANG_PB00101: {
						name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'],
						url: '/zz_common_pb10020',
						hint: [],
						ZZ_SYUGUANG_PB00101: { name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'] },
					},
					ZZ_SYUGUANG_PB00102: {
						name: ['薪資報表', 'Salary report', '薪资报表'],
						url: '/zz_common_pb10021',
						hint: [],
						ZZ_SYUGUANG_PB00102: { name: ['薪資報表', 'Salary report', '薪资报表'] }, 
					},					
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};